export default {
  type: 'object',
  properties: {
    public: {
      default: null,
      type: 'boolean',
      enum: [true, false],
      validationMessages: {
        enum:
          'Proszę wybrać, czy szkoła jest szkołą prowadzoną przez Miasto Lublin, czy prowadzoną przez inne podmioty .'
      }
    }
  }
};
